(function ($, ko) {
    const REQUIRED_ATTENTION_MFE_SOURCE = 'transactions';
    const REQUIRED_ATTENTION_TARGET_ROUTE_KEY = 'dashboard';

    var attentionItemsModel = function (updateHeight, template) {
        
        this.templateExtractor = new $.cdh.services.templateExtractor(template);
        this.itemsRequest = new $.cdh.get.claims.getRequiredAttentionItems();
        this.itemsRequestLoading = ko.observable(true);
        this.syncItem = ko.observable().syncWith($.cdh.topics.claims.requiredAttentionItems);
        this.items = [];

        this.itemsRequest.load().done(function(result) {
            this.items = $.grep(result,
                function(t) {
                    t.Actionable = ko.observable(true);
                    t.Status = ko.observable(t.Status);
                    t.ReceiptsCount = ko.observable(t.ReceiptsCount);
                    t.Receipts = ko.observable(t.Receipts);
                    t.faxCoverUrl = ko.observable();
                    t.openAddReceiptPopup = ko.observable(false);
                    t.isAiAdjudicationSettingsLoading = ko.observable(false);
                    t.sourceTranDesc = `Required Attention Items. ClaimKey: ${t.ClaimKey || ''}, TransactionId: ${t.TransactionId || ''}, Type: ${t.Type || ''}`;
                    return true;
                }.bind(this));
            var requiredAttentionItemsWidget = $('div.required-attention-items-block');
            var horizontalSwitchingWidth = requiredAttentionItemsWidget.data('horizontal-switching-width');

            function setStructure() {
                if (requiredAttentionItemsWidget.outerWidth() >= horizontalSwitchingWidth) {
                    requiredAttentionItemsWidget.addClass('horizontal');
                } else {
                    requiredAttentionItemsWidget.removeClass('horizontal');
                }
            }

            $(window).on('resize',
                _.debounce(function() {
                        setStructure();
                    },
                    300));
            setStructure();

            this.itemsRequestLoading(false);
        }.bind(this));

        this.filteredItems = ko.pureComputed(function () {

            if (this.itemsRequestLoading ())
                return [];

            if (this.syncItem() !== undefined) {
                $.each(this.items,
                    function (i, c) {
                        c.Actionable(true);
                        if (this.syncItem().isClaim && c.ClaimKey === this.syncItem().claimKey) {
                            c.Actionable(false);
                        }
                        if (!this.syncItem().isClaim && c.TransactionId === this.syncItem().transactionId) {
                            c.Actionable(false);
                        }
                    }.bind(this));
            }

            var items =  $.grep(this.items,
                function(t) {
                    return t.Actionable();
                }.bind(this));

            if (items.length === 0) {
                var widget = $("required-attention-items");
                $.cdh.helper.removeWidget(widget);
            }
            
            $.each(items, function(i, item){
                if(!item.AllowFaxCover)
                    return;
                
                item.faxCoverUrl($.cdh.routes.claims.downloadFaxCover({trackingNumber: item.TrackingNumber, pdf: true}));
            }.bind(this));

            return items;
        }, this);
        
        this.openLegacyAddReceiptPopup = function(item) {
            item.openAddReceiptPopup(false);
            item.openAddReceiptPopup(true);
        };

        this.getAddReceiptTransactionContext = function(item) {
            let key = item.TrnKey;

            if (Array.isArray(key) && key[0]) {
                key = key[0];
            }

            if (
                !key ||
                !key.Id ||
                !key.SettlementDate ||
                key.SeqNumber === undefined ||
                key.SeqNumber === null
            ) {
                return null;
            }

            return {
                transactionId: key.Id,
                settlementDate: key.SettlementDate,
                sequenceNumber: key.SeqNumber
            };
        };

        this.isMfeEligibleRequiredAttentionItem = function(item) {
            const typeValue = (item.Type || '').toString().toLowerCase().trim();
            return typeValue === 'card';
        };

        this.getAddReceiptMfeUrl = function(context) {
            const query = $.param({
                source: REQUIRED_ATTENTION_MFE_SOURCE,
                targetRouteKey: REQUIRED_ATTENTION_TARGET_ROUTE_KEY,
                transactionId: context.transactionId,
                sequenceNumber: context.sequenceNumber,
                settlementDate: context.settlementDate
            });

            return `${$.cdh.routes.predefined.mfe.addReceipt}?${query}`;
        };

        this.onAddReceiptClick = function(item, event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            const context = this.getAddReceiptTransactionContext(item);

            if (!this.isMfeEligibleRequiredAttentionItem(item) || !context) {
                this.openLegacyAddReceiptPopup(item);
                return false;
            }

            if (item.isAiAdjudicationSettingsLoading()) {
                return false;
            }

            item.isAiAdjudicationSettingsLoading(true);

            $.ajax({
                url: $.cdh.routes.transactions.getAiAdjudicationSettings({
                    transactionId: context.transactionId,
                    sequenceNumber: context.sequenceNumber,
                    settlementDate: context.settlementDate
                }),
                method: 'GET'
            }).done(function(response) {
                let isAiEnabled = response && response.Data && response.Data.IsAIAdjudicationEnabled === true;

                if (isAiEnabled) {
                    window.location.href = this.getAddReceiptMfeUrl(context);
                    return;
                }

                this.openLegacyAddReceiptPopup(item);
            }.bind(this)).fail(function() {
                this.openLegacyAddReceiptPopup(item);
            }.bind(this)).always(function() {
                item.isAiAdjudicationSettingsLoading(false);
            });

            return false;
        }.bind(this);

        this.filteredItems.subscribe(updateHeight);
    };

    ko.components.register('required-attention-items', {
        template: { element: 'template-required-attention-items' },
        viewModel: {
            createViewModel: function (params, componentInfo) {
                var updateHeight = updateContainerHeight(componentInfo.element);
                return new attentionItemsModel(updateHeight, params.template);
            }
        }
    });
})(jQuery, ko);
